import React from 'react';
import PropTypes from 'prop-types';

import ErrorComponent from '../../../components/Error';

import { useApi } from '../../../utils/hooks';

function NewsCategories({ setActiveCategory, activeCategory }) {
    const { data, loading, error } = useApi('news-category/');

    // Display the error message if the request fails
    if (loading) return <div className="container">Chargement...</div>;

    // Display a loading message while the request is pending
    if (error) return <ErrorComponent title="Error" errorObject={error} />;

    return (
        <div id="news-category">
            <button
                onClick={() => setActiveCategory('')}
                className={
                    activeCategory === '' ? 'button-2 active' : 'button-2'
                }
                key="all"
            >
                Tout
            </button>
            {data?.results?.map(({ id, name }) => (
                <button
                    onClick={() => setActiveCategory(name)}
                    className={
                        activeCategory === name
                            ? 'button-2 active'
                            : 'button-2'
                    }
                    key={id}
                >
                    {name}
                </button>
            ))}
        </div>
    );
}

NewsCategories.propTypes = {
    setActiveCategory: PropTypes.func.isRequired,
    activeCategory: PropTypes.string.isRequired,
};

export default NewsCategories;
